// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/auth-client/components/loader/loader.component.sass"],"names":[],"mappings":"AAAC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AACF","sourcesContent":["\\:host\n  display: flex\n  justify-content: center\n  align-items: center\n  height: 100vh\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
